import { FC, SVGProps } from "react";

import AdminLogoImage from "@/assets/admin-logo.svg?react";
import CustomerLogoImage from "@/assets/customer-logo.svg?react";

interface LogoProps extends SVGProps<SVGSVGElement> {
  type?: "admin" | "customer";
}

export const Logo: FC<LogoProps> = ({ type = "admin", ...props }) => {
  if (type === "admin") return <AdminLogoImage {...props} />;
  if (type === "customer") return <CustomerLogoImage {...props} />;
};
